import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'

import Video from './Video'
import VideoPlayButton from './VideoPlayButton'

class VideoPlayer extends Component {
  constructor () {
    super()
    this.state = {
      isPlaying: false
    }
  }
  render () {
    const { isPlaying } = this.state
    const {
      src,
      iframe,
      iframeHeight,
      videoPlayerExtraClass,
      videoClassName,
      ...videoProps
    } = this.props
    return (
      <div
        className={classnames(videoPlayerExtraClass, 'video-player relative')}
      >
        {!isPlaying && (
          <VideoPlayButton onClick={() => this.setState({ isPlaying: true })} />
        )}
        {!iframe && (
          <Video
            src={src}
            isPlaying={isPlaying}
            controls={isPlaying}
            className={videoClassName}
            {...videoProps}
          />
        )}
        {iframe && (
          <div className={videoClassName}>
            <iframe
              key={src}
              src={src + (isPlaying ? '?autoplay=1' : '')}
              ref={ref => {
                this.iframeRef = ref
              }}
              height={iframeHeight}
              className='col-12'
              frameborder='0'
              allowfullscreen
            />
          </div>
        )}
      </div>
    )
  }
}

VideoPlayer.propTypes = {
  src: PropTypes.string.isRequired,
  iframe: PropTypes.boolean,
  iframeHeight: PropTypes.number,
  poster: PropTypes.string,
  videoPlayerExtraClass: PropTypes.string,
  videoClassName: PropTypes.string
}

VideoPlayer.defaultProps = {
  iframeHeight: 500
}

export default VideoPlayer



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/VideoPlayer.js